<template>
  <div class="form-group">
    <label :for="id">{{ label }}</label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        v-model="uuidToAdd"
        @keypress.enter="selectItem"
        placeholder="Paste Item ID here">
      <span class="input-group-btn">
        <button
          class="btn btn-default"
          @click="selectItem"
          :disabled="!uuidToAdd"
          type="button">Select</button>
      </span>
    </div>
    <div class="help-block">
      <i v-if="validating" class="fa fa-circle-o-notch fa-spin"/>
      <span v-if="showError" class="text-danger">Not a valid item ID</span>
    </div>
    <ul class="list-group">
      <li
        class="list-group-item"
        v-for="item of selectedItemsReadOnly"
        :key="item">
        <a :href="itemURL(item)" target="_blank">Item {{ item }}</a>
        <a
          class="remove text-danger"
          role="button"
          :aria-label="`Remove ${item}`"
          @click="$emit('remove', item)">
          <i class="fa fa-times"/>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { pathwaysUrls } from '@/links'

export default {
  name: 'SelectAssessmentItemsInput',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Select Assessment Items'
    },
    // read-only so we can display the list and expose events that users take on the list
    selectedItemsReadOnly: {
      type: Array,
      default: () => []
    },
    // function that accepts an item ID string and determines whether it is a valid item. Should return a promise that resolves if the id is valid, and rejects otherwise
    asyncValidateFunction: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      uuidToAdd: '',
      valid: null,
      validating: false
    }
  },
  computed: {
    showError() {
      return this.valid === false && !this.validating
    }
  },
  methods: {
    async selectItem() {
      if (
        !this.uuidToAdd ||
        (this.selectedItemsReadOnly && this.selectedItemsReadOnly.includes(this.uuidToAdd))
      ) {
        this.uuidToAdd = ''
        return
      }
      await this.validate()
      if (this.valid) {
        this.$emit('add', this.uuidToAdd)
        this.uuidToAdd = ''
      }
    },
    async validate() {
      this.valid = null
      if (this.uuidToAdd) {
        try {
          this.validating = true
          await this.asyncValidateFunction(this.uuidToAdd)
          this.valid = true
        } catch {
          this.valid = false
        } finally {
          this.validating = false
        }
      } else {
        this.valid = false
      }
    },
    itemURL(item) {
      return pathwaysUrls.itemDetail(item)
    }
  }
}
</script>

<style lang="less" scoped>
.input-group {
  margin-bottom: 1em;
}
.list-group-item {
  display: flex;
  a {
    flex: 1 1 auto;
  }
  .remove {
    flex: 0 0 auto;
  }
}
</style>
